import { l as Je, g as le, a as K, c as N, _ as x, $ as et, e as tt, h as I, f as ae, j as nt, b as rt, m as ot, n as at } from "./index-oCgrS4gV.js";
import * as u from "react";
import { forwardRef as w, useState as ye, useRef as R, useEffect as V, useCallback as Ee, createElement as y, Children as ct, Fragment as it } from "react";
import { CloseIcon as lt } from "@spiaggeit/spit-icons";
import { cva as ut } from "class-variance-authority";
import { c as ue } from "./cn-Edy-X8i3.js";
const st = u.useId || (() => {
});
let dt = 0;
function X(e) {
  const [t, n] = u.useState(st());
  return Je(() => {
    e || n(
      (r) => r ?? String(dt++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Z = "focusScope.autoFocusOnMount", q = "focusScope.autoFocusOnUnmount", se = {
  bubbles: !1,
  cancelable: !0
}, ft = /* @__PURE__ */ w((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...l } = e, [c, p] = ye(null), g = le(o), f = le(a), d = R(null), v = K(
    t,
    (i) => p(i)
  ), b = R({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  V(() => {
    if (r) {
      let i = function(h) {
        if (b.paused || !c)
          return;
        const $ = h.target;
        c.contains($) ? d.current = $ : O(d.current, {
          select: !0
        });
      }, s = function(h) {
        if (b.paused || !c)
          return;
        const $ = h.relatedTarget;
        $ !== null && (c.contains($) || O(d.current, {
          select: !0
        }));
      }, m = function(h) {
        if (document.activeElement === document.body)
          for (const E of h)
            E.removedNodes.length > 0 && O(c);
      };
      document.addEventListener("focusin", i), document.addEventListener("focusout", s);
      const C = new MutationObserver(m);
      return c && C.observe(c, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", i), document.removeEventListener("focusout", s), C.disconnect();
      };
    }
  }, [
    r,
    c,
    b.paused
  ]), V(() => {
    if (c) {
      fe.add(b);
      const i = document.activeElement;
      if (!c.contains(i)) {
        const m = new CustomEvent(Z, se);
        c.addEventListener(Z, g), c.dispatchEvent(m), m.defaultPrevented || (vt(ht(Ce(c)), {
          select: !0
        }), document.activeElement === i && O(c));
      }
      return () => {
        c.removeEventListener(Z, g), setTimeout(() => {
          const m = new CustomEvent(q, se);
          c.addEventListener(q, f), c.dispatchEvent(m), m.defaultPrevented || O(i ?? document.body, {
            select: !0
          }), c.removeEventListener(q, f), fe.remove(b);
        }, 0);
      };
    }
  }, [
    c,
    g,
    f,
    b
  ]);
  const S = Ee((i) => {
    if (!n && !r || b.paused)
      return;
    const s = i.key === "Tab" && !i.altKey && !i.ctrlKey && !i.metaKey, m = document.activeElement;
    if (s && m) {
      const C = i.currentTarget, [h, $] = mt(C);
      h && $ ? !i.shiftKey && m === $ ? (i.preventDefault(), n && O(h, {
        select: !0
      })) : i.shiftKey && m === h && (i.preventDefault(), n && O($, {
        select: !0
      })) : m === C && i.preventDefault();
    }
  }, [
    n,
    r,
    b.paused
  ]);
  return /* @__PURE__ */ y(N.div, x({
    tabIndex: -1
  }, l, {
    ref: v,
    onKeyDown: S
  }));
});
function vt(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (O(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function mt(e) {
  const t = Ce(e), n = de(t, e), r = de(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Ce(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function de(e, t) {
  for (const n of e)
    if (!gt(n, {
      upTo: t
    }))
      return n;
}
function gt(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function pt(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function O(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && pt(e) && t && e.select();
  }
}
const fe = bt();
function bt() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ve(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ve(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function ve(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function ht(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
let Q = 0;
function $t() {
  V(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : me()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : me()), Q++, () => {
      Q === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Q--;
    };
  }, []);
}
function me() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var D = function() {
  return D = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, D.apply(this, arguments);
};
function Se(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function yt(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var z = "right-scroll-bar-position", U = "width-before-scroll-bar", Et = "with-scroll-bars-hidden", Ct = "--removed-body-scroll-bar-size";
function J(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function St(e, t) {
  var n = ye(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var ge = /* @__PURE__ */ new WeakMap();
function xt(e, t) {
  var n = St(t || null, function(r) {
    return e.forEach(function(o) {
      return J(o, r);
    });
  });
  return u.useLayoutEffect(function() {
    var r = ge.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), l = n.current;
      o.forEach(function(c) {
        a.has(c) || J(c, null);
      }), a.forEach(function(c) {
        o.has(c) || J(c, l);
      });
    }
    ge.set(n, e);
  }, [e]), n;
}
function wt(e) {
  return e;
}
function _t(e, t) {
  t === void 0 && (t = wt);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var l = t(a, r);
      return n.push(l), function() {
        n = n.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(a);
      }
      n = {
        push: function(c) {
          return a(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var l = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(a), l = n;
      }
      var p = function() {
        var f = l;
        l = [], f.forEach(a);
      }, g = function() {
        return Promise.resolve().then(p);
      };
      g(), n = {
        push: function(f) {
          l.push(f), g();
        },
        filter: function(f) {
          return l = l.filter(f), n;
        }
      };
    }
  };
  return o;
}
function Dt(e) {
  e === void 0 && (e = {});
  var t = _t(null);
  return t.options = D({ async: !0, ssr: !1 }, e), t;
}
var xe = function(e) {
  var t = e.sideCar, n = Se(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return u.createElement(r, D({}, n));
};
xe.isSideCarExport = !0;
function Ot(e, t) {
  return e.useMedium(t), xe;
}
var we = Dt(), ee = function() {
}, Y = u.forwardRef(function(e, t) {
  var n = u.useRef(null), r = u.useState({
    onScrollCapture: ee,
    onWheelCapture: ee,
    onTouchMoveCapture: ee
  }), o = r[0], a = r[1], l = e.forwardProps, c = e.children, p = e.className, g = e.removeScrollBar, f = e.enabled, d = e.shards, v = e.sideCar, b = e.noIsolation, S = e.inert, i = e.allowPinchZoom, s = e.as, m = s === void 0 ? "div" : s, C = Se(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), h = v, $ = xt([n, t]), E = D(D({}, C), o);
  return u.createElement(
    u.Fragment,
    null,
    f && u.createElement(h, { sideCar: we, removeScrollBar: g, shards: d, noIsolation: b, inert: S, setCallbacks: a, allowPinchZoom: !!i, lockRef: n }),
    l ? u.cloneElement(u.Children.only(c), D(D({}, E), { ref: $ })) : u.createElement(m, D({}, E, { className: p, ref: $ }), c)
  );
});
Y.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Y.classNames = {
  fullWidth: U,
  zeroRight: z
};
var pe, Rt = function() {
  if (pe)
    return pe;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Tt() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Rt();
  return t && e.setAttribute("nonce", t), e;
}
function At(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Pt(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Mt = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Tt()) && (At(t, n), Pt(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Nt = function() {
  var e = Mt();
  return function(t, n) {
    u.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, _e = function() {
  var e = Nt(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, kt = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, te = function(e) {
  return parseInt(e || "", 10) || 0;
}, It = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [te(n), te(r), te(o)];
}, Ft = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return kt;
  var t = It(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Lt = _e(), H = "data-scroll-locked", Wt = function(e, t, n, r) {
  var o = e.left, a = e.top, l = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Et, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(H, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(z, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(U, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(z, " .").concat(z, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(U, " .").concat(U, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(H, `] {
    `).concat(Ct, ": ").concat(c, `px;
  }
`);
}, Bt = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, a = u.useMemo(function() {
    return Ft(o);
  }, [o]);
  return u.useEffect(function() {
    return document.body.setAttribute(H, ""), function() {
      document.body.removeAttribute(H);
    };
  }, []), u.createElement(Lt, { styles: Wt(a, !t, o, n ? "" : "!important") });
}, re = !1;
if (typeof window < "u")
  try {
    var L = Object.defineProperty({}, "passive", {
      get: function() {
        return re = !0, !0;
      }
    });
    window.addEventListener("test", L, L), window.removeEventListener("test", L, L);
  } catch {
    re = !1;
  }
var T = re ? { passive: !1 } : !1, jt = function(e) {
  return e.tagName === "TEXTAREA";
}, De = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !jt(e) && n[t] === "visible")
  );
}, zt = function(e) {
  return De(e, "overflowY");
}, Ut = function(e) {
  return De(e, "overflowX");
}, be = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Oe(e, n);
    if (r) {
      var o = Re(e, n), a = o[1], l = o[2];
      if (a > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Vt = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Ht = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Oe = function(e, t) {
  return e === "v" ? zt(t) : Ut(t);
}, Re = function(e, t) {
  return e === "v" ? Vt(t) : Ht(t);
}, Kt = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Yt = function(e, t, n, r, o) {
  var a = Kt(e, window.getComputedStyle(t).direction), l = a * r, c = n.target, p = t.contains(c), g = !1, f = l > 0, d = 0, v = 0;
  do {
    var b = Re(e, c), S = b[0], i = b[1], s = b[2], m = i - s - a * S;
    (S || m) && Oe(e, c) && (d += m, v += S), c = c.parentNode;
  } while (
    // portaled content
    !p && c !== document.body || // self content
    p && (t.contains(c) || t === c)
  );
  return (f && (o && d === 0 || !o && l > d) || !f && (o && v === 0 || !o && -l > v)) && (g = !0), g;
}, W = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, he = function(e) {
  return [e.deltaX, e.deltaY];
}, $e = function(e) {
  return e && "current" in e ? e.current : e;
}, Gt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Xt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Zt = 0, A = [];
function qt(e) {
  var t = u.useRef([]), n = u.useRef([0, 0]), r = u.useRef(), o = u.useState(Zt++)[0], a = u.useState(function() {
    return _e();
  })[0], l = u.useRef(e);
  u.useEffect(function() {
    l.current = e;
  }, [e]), u.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var i = yt([e.lockRef.current], (e.shards || []).map($e), !0).filter(Boolean);
      return i.forEach(function(s) {
        return s.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), i.forEach(function(s) {
          return s.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = u.useCallback(function(i, s) {
    if ("touches" in i && i.touches.length === 2)
      return !l.current.allowPinchZoom;
    var m = W(i), C = n.current, h = "deltaX" in i ? i.deltaX : C[0] - m[0], $ = "deltaY" in i ? i.deltaY : C[1] - m[1], E, G = i.target, k = Math.abs(h) > Math.abs($) ? "h" : "v";
    if ("touches" in i && k === "h" && G.type === "range")
      return !1;
    var F = be(k, G);
    if (!F)
      return !0;
    if (F ? E = k : (E = k === "v" ? "h" : "v", F = be(k, G)), !F)
      return !1;
    if (!r.current && "changedTouches" in i && (h || $) && (r.current = E), !E)
      return !0;
    var ie = r.current || E;
    return Yt(ie, s, i, ie === "h" ? h : $, !0);
  }, []), p = u.useCallback(function(i) {
    var s = i;
    if (!(!A.length || A[A.length - 1] !== a)) {
      var m = "deltaY" in s ? he(s) : W(s), C = t.current.filter(function(E) {
        return E.name === s.type && E.target === s.target && Gt(E.delta, m);
      })[0];
      if (C && C.should) {
        s.cancelable && s.preventDefault();
        return;
      }
      if (!C) {
        var h = (l.current.shards || []).map($e).filter(Boolean).filter(function(E) {
          return E.contains(s.target);
        }), $ = h.length > 0 ? c(s, h[0]) : !l.current.noIsolation;
        $ && s.cancelable && s.preventDefault();
      }
    }
  }, []), g = u.useCallback(function(i, s, m, C) {
    var h = { name: i, delta: s, target: m, should: C };
    t.current.push(h), setTimeout(function() {
      t.current = t.current.filter(function($) {
        return $ !== h;
      });
    }, 1);
  }, []), f = u.useCallback(function(i) {
    n.current = W(i), r.current = void 0;
  }, []), d = u.useCallback(function(i) {
    g(i.type, he(i), i.target, c(i, e.lockRef.current));
  }, []), v = u.useCallback(function(i) {
    g(i.type, W(i), i.target, c(i, e.lockRef.current));
  }, []);
  u.useEffect(function() {
    return A.push(a), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", p, T), document.addEventListener("touchmove", p, T), document.addEventListener("touchstart", f, T), function() {
      A = A.filter(function(i) {
        return i !== a;
      }), document.removeEventListener("wheel", p, T), document.removeEventListener("touchmove", p, T), document.removeEventListener("touchstart", f, T);
    };
  }, []);
  var b = e.removeScrollBar, S = e.inert;
  return u.createElement(
    u.Fragment,
    null,
    S ? u.createElement(a, { styles: Xt(o) }) : null,
    b ? u.createElement(Bt, { gapMode: "margin" }) : null
  );
}
const Qt = Ot(we, qt);
var Te = u.forwardRef(function(e, t) {
  return u.createElement(Y, D({}, e, { ref: t, sideCar: Qt }));
});
Te.classNames = Y.classNames;
const Jt = Te;
var en = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, P = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), j = {}, ne = 0, Ae = function(e) {
  return e && (e.host || Ae(e.parentNode));
}, tn = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ae(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, nn = function(e, t, n, r) {
  var o = tn(t, Array.isArray(e) ? e : [e]);
  j[n] || (j[n] = /* @__PURE__ */ new WeakMap());
  var a = j[n], l = [], c = /* @__PURE__ */ new Set(), p = new Set(o), g = function(d) {
    !d || c.has(d) || (c.add(d), g(d.parentNode));
  };
  o.forEach(g);
  var f = function(d) {
    !d || p.has(d) || Array.prototype.forEach.call(d.children, function(v) {
      if (c.has(v))
        f(v);
      else {
        var b = v.getAttribute(r), S = b !== null && b !== "false", i = (P.get(v) || 0) + 1, s = (a.get(v) || 0) + 1;
        P.set(v, i), a.set(v, s), l.push(v), i === 1 && S && B.set(v, !0), s === 1 && v.setAttribute(n, "true"), S || v.setAttribute(r, "true");
      }
    });
  };
  return f(t), c.clear(), ne++, function() {
    l.forEach(function(d) {
      var v = P.get(d) - 1, b = a.get(d) - 1;
      P.set(d, v), a.set(d, b), v || (B.has(d) || d.removeAttribute(r), B.delete(d)), b || d.removeAttribute(n);
    }), ne--, ne || (P = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), j = {});
  };
}, rn = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || en(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), nn(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
const Pe = "Dialog", [Me, on] = et(Pe), [an, _] = Me(Pe), Ne = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: l = !0 } = e, c = R(null), p = R(null), [g = !1, f] = tt({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ y(an, {
    scope: t,
    triggerRef: c,
    contentRef: p,
    contentId: X(),
    titleId: X(),
    descriptionId: X(),
    open: g,
    onOpenChange: f,
    onOpenToggle: Ee(
      () => f(
        (d) => !d
      ),
      [
        f
      ]
    ),
    modal: l
  }, n);
}, cn = "DialogTrigger", ke = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = _(cn, n), a = K(t, o.triggerRef);
  return /* @__PURE__ */ y(N.button, x({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": ce(o.open)
  }, r, {
    ref: a,
    onClick: I(e.onClick, o.onOpenToggle)
  }));
}), Ie = "DialogPortal", [ln, Fe] = Me(Ie, {
  forceMount: void 0
}), Le = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = _(Ie, t);
  return /* @__PURE__ */ y(ln, {
    scope: t,
    forceMount: n
  }, ct.map(
    r,
    (l) => /* @__PURE__ */ y(ae, {
      present: n || a.open
    }, /* @__PURE__ */ y(nt, {
      asChild: !0,
      container: o
    }, l))
  ));
}, oe = "DialogOverlay", We = /* @__PURE__ */ w((e, t) => {
  const n = Fe(oe, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = _(oe, e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ y(ae, {
    present: r || a.open
  }, /* @__PURE__ */ y(un, x({}, o, {
    ref: t
  }))) : null;
}), un = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = _(oe, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ y(Jt, {
      as: rt,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ y(N.div, x({
      "data-state": ce(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), M = "DialogContent", Be = /* @__PURE__ */ w((e, t) => {
  const n = Fe(M, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = _(M, e.__scopeDialog);
  return /* @__PURE__ */ y(ae, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ y(sn, x({}, o, {
    ref: t
  })) : /* @__PURE__ */ y(dn, x({}, o, {
    ref: t
  })));
}), sn = /* @__PURE__ */ w((e, t) => {
  const n = _(M, e.__scopeDialog), r = R(null), o = K(t, n.contentRef, r);
  return V(() => {
    const a = r.current;
    if (a)
      return rn(a);
  }, []), /* @__PURE__ */ y(je, x({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: I(e.onCloseAutoFocus, (a) => {
      var l;
      a.preventDefault(), (l = n.triggerRef.current) === null || l === void 0 || l.focus();
    }),
    onPointerDownOutside: I(e.onPointerDownOutside, (a) => {
      const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
      (l.button === 2 || c) && a.preventDefault();
    }),
    onFocusOutside: I(
      e.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), dn = /* @__PURE__ */ w((e, t) => {
  const n = _(M, e.__scopeDialog), r = R(!1), o = R(!1);
  return /* @__PURE__ */ y(je, x({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var l;
      if ((l = e.onCloseAutoFocus) === null || l === void 0 || l.call(e, a), !a.defaultPrevented) {
        var c;
        r.current || (c = n.triggerRef.current) === null || c === void 0 || c.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var l, c;
      (l = e.onInteractOutside) === null || l === void 0 || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const p = a.target;
      ((c = n.triggerRef.current) === null || c === void 0 ? void 0 : c.contains(p)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), je = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...l } = e, c = _(M, n), p = R(null), g = K(t, p);
  return $t(), /* @__PURE__ */ y(it, null, /* @__PURE__ */ y(ft, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ y(ot, x({
    role: "dialog",
    id: c.contentId,
    "aria-describedby": c.descriptionId,
    "aria-labelledby": c.titleId,
    "data-state": ce(c.open)
  }, l, {
    ref: g,
    onDismiss: () => c.onOpenChange(!1)
  }))), !1);
}), ze = "DialogTitle", Ue = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = _(ze, n);
  return /* @__PURE__ */ y(N.h2, x({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), fn = "DialogDescription", Ve = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = _(fn, n);
  return /* @__PURE__ */ y(N.p, x({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), vn = "DialogClose", He = /* @__PURE__ */ w((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = _(vn, n);
  return /* @__PURE__ */ y(N.button, x({
    type: "button"
  }, r, {
    ref: t,
    onClick: I(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function ce(e) {
  return e ? "open" : "closed";
}
const mn = "DialogTitleWarning", [gn, Sn] = at(mn, {
  contentName: M,
  titleName: ze,
  docsSlug: "dialog"
}), Ke = Ne, Ye = ke, Ge = Le, Xe = We, Ze = Be, qe = Ue, pn = Ve, Qe = He, xn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Close: Qe,
  Content: Ze,
  Description: pn,
  Dialog: Ne,
  DialogClose: He,
  DialogContent: Be,
  DialogDescription: Ve,
  DialogOverlay: We,
  DialogPortal: Le,
  DialogTitle: Ue,
  DialogTrigger: ke,
  Overlay: Xe,
  Portal: Ge,
  Root: Ke,
  Title: qe,
  Trigger: Ye,
  WarningProvider: gn,
  createDialogScope: on
}, Symbol.toStringTag, { value: "Module" })), bn = ut(
  "fixed z-500 flex max-h-[calc(100%-3rem)] w-full flex-col overflow-hidden bg-white shadow-sm duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 lg:max-h-[calc(100%-4rem)]",
  {
    variants: {
      mobileMode: {
        bottomSheet: [
          "inset-x-0 bottom-0 rounded-t lg:bottom-auto lg:left-1/2 lg:right-auto lg:top-1/2 lg:max-w-lg lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded lg:data-[state=closed]:slide-out-to-left-1/2 lg:data-[state=open]:slide-in-from-left-1/2"
        ],
        fullscreen: [
          "inset-x-0 bottom-0 h-full max-h-none lg:bottom-auto lg:left-1/2 lg:right-auto lg:top-1/2 lg:h-auto lg:max-w-lg lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded lg:data-[state=closed]:slide-out-to-left-1/2 lg:data-[state=open]:slide-in-from-left-1/2"
        ],
        default: [
          "left-1/2 top-1/2 max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 rounded data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2"
        ]
      },
      size: {
        sm: ["lg:max-w-sm"],
        md: ["lg:max-w-xl"]
      }
    },
    compoundVariants: [
      {
        mobileMode: "default",
        size: "sm",
        class: "sm:max-w-sm"
      },
      {
        mobileMode: "default",
        size: "md",
        class: "sm:max-w-lg"
      }
    ],
    defaultVariants: {
      mobileMode: "default",
      size: "md"
    }
  }
);
function wn(e) {
  return /* @__PURE__ */ u.createElement(Ke, { open: e.isOpen, onOpenChange: e.setIsOpen }, /* @__PURE__ */ u.createElement(Ye, { asChild: !0 }, e.trigger), /* @__PURE__ */ u.createElement(Ge, null, /* @__PURE__ */ u.createElement(Xe, { className: "fixed inset-0 z-500 bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" }), /* @__PURE__ */ u.createElement(
    Ze,
    {
      className: ue(
        bn({ mobileMode: e.mobileMode, size: e.size }),
        e.className
      )
    },
    e.title ? /* @__PURE__ */ u.createElement(
      qe,
      {
        className: ue(
          "flex shrink-0 items-center justify-between gap-4 p-4 text-base",
          {
            "border-b": !!e.scrollContent
          }
        )
      },
      /* @__PURE__ */ u.createElement("span", { className: "font-bold" }, e.title),
      /* @__PURE__ */ u.createElement(Qe, { className: "shrink-0 select-none text-secondary transition-colors hover:text-primary focus-visible:outline-none" }, /* @__PURE__ */ u.createElement(lt, { className: "size-6" }))
    ) : null,
    e.scrollContent ? /* @__PURE__ */ u.createElement("div", { className: "grow overflow-y-auto" }, e.children) : e.children
  )));
}
export {
  wn as D,
  xn as i
};
